import * as React from 'react';
import { useQuery } from '@tanstack/react-query';
import { useListScheduledReports } from 'hooks/api/reports';
import { ScheduledStockBalanceReport } from 'contracts/scheduledRepports';
import { DataTable } from 'components/ui/DataTable';
import { getColumns } from './columns';

const columns = getColumns();

export const StockBalance = () => {
  const { listReports } =
    useListScheduledReports<ScheduledStockBalanceReport>();

  const fetchReportsList = React.useCallback(() => {
    return listReports({
      type: 'stock-balance',
    });
  }, []);

  const { data: scheduledReports, isLoading: loadingScheduledReports } =
    useQuery({
      queryKey: ['listReports'],
      queryFn: fetchReportsList,
      initialData: [],
    });

  return (
    <section className="w-full h-auto">
      <DataTable
        data={scheduledReports ?? []}
        columns={columns}
        showControlColumns={false}
        isLoading={loadingScheduledReports}
      />
    </section>
  );
};
